import React, {Component} from 'react';
import NumberFormat from 'react-number-format';
import { connect } from 'react-redux';
import * as actionTypes from '../../store/actions';
import classes from './AllocationCategory.css';

export class AllocationCategory extends Component {

    state = {
        expanded: false
    };

    toggleExpand = () => {
        let newState = Object.assign({}, this.state);
        newState.expanded = !newState.expanded;
        this.setState(newState);
    };


    clearEntryOnClick = (categoryId, assetId) => {

        if(!this.props.editable) return;

        this.props.updateAllocationInfo({
            categoryId: categoryId,
            assetId: assetId,
            value: ""
        });
    };

    render() {

        let plusStyle = {
            display: "none"
        };

        let minusStyle = {
            display: "inline"
        };

        let assetListClasses = [classes.assets];
        let wrapperClass = [classes.AllocationCategory];

        if (!this.state.expanded) {
            assetListClasses.push(classes.collapsed);

            plusStyle = {
                display: "inline"
            };

            minusStyle = {
                display: "none"
            };
        } else {
            wrapperClass.push(classes.greenBorder);
        }

        let decimalScale = 0;
        let displayType = 'input';
        if (!this.props.editable) {
            displayType = 'text';
            decimalScale = 1;
        }

        let assetClassList = this.props.assets.map((asset) => {
            return (
                <div key={asset.assetId} className={classes.subAsset}>
                    <label>{asset.name}</label>
                    <NumberFormat
                        onValueChange={(values) => this.props.updateAllocationInfo({
                            categoryId: this.props.categoryId,
                            assetId: asset.assetId,
                            value: values.value
                        })}
                        onClick={() => {this.clearEntryOnClick(this.props.categoryId, asset.assetId);}}
                        onBlur={() => this.props.updateAllocationInfo({
                            categoryId: this.props.categoryId,
                            assetId: asset.assetId,
                            value: "BLUR"
                        })}
                        value={asset.value}
                        displayType={displayType}
                        suffix={'%'}
                        decimalScale={decimalScale}
                        fixedDecimalScale="false"
                    />
                </div>
            );
        });



        return (
            <div className={wrapperClass.join(' ')}>
                <div className={classes.title}>
                    <label>
                        <div style={plusStyle} onClick={this.toggleExpand} className={classes.assetHandle}><i className="fas fa-plus-circle"></i></div>
                        <div style={minusStyle} onClick={this.toggleExpand} className={classes.assetHandle}><i className="fas fa-minus-circle"></i></div>
                        {this.props.title}
                        <span>{this.props.total}%</span>
                    </label>
                </div>
                <div className={assetListClasses.join(' ')}>
                    {assetClassList}
                </div>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        updateAllocationInfo: (data) => dispatch({
            type: actionTypes.ASSET_UPDATE,
            data: data
        })
    }
};

export default connect(null, mapDispatchToProps)(AllocationCategory);


// WEBPACK FOOTER //
// ./src/containers/AllocationCategory/AllocationCategory.js